import type { FormikProps } from 'formik';

import './CustomerLeadStepQuantitiesTab.scss';

import { SelectField, TextInputField } from 'src/components/base';
import { YesNoSelectField } from 'src/components/base/fields/YesNoSelectField';
import type { ICustomerLeadProductFrequencyTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import { CustomerLeadStepLayoutNextButton } from 'src/components/customers/steps/CustomerLeadStepLayoutNextButton';
import { useDebounceEffect } from 'src/hooks/useDebounceEffect';
import { CustomerLeadPurchaseFrequencyOptions } from 'src/types/customers/CustomerLeadPurchaseFrequency';

type CustomerLeadStepContactTabProps = {
  formikProps: FormikProps<ICustomerLeadProductFrequencyTabFormValues>;

  onChange: (newValues: ICustomerLeadProductFrequencyTabFormValues) => void;
};

export function CustomerLeadStepFrequencyTabContent({
  formikProps: { values, validateForm },
  onChange,
}: Readonly<CustomerLeadStepContactTabProps>) {
  useDebounceEffect(
    () => {
      void (async () => {
        const errors = await validateForm(values);

        if (Object.keys(errors).length === 0) {
          onChange(values);
        }
      })();
    },
    [values],
    1000
  );

  return (
    <div className="customer-lead-step-quantities-tab__container">
      <div className="customer-lead-step-quantities-tab__container__row">
        <SelectField
          name="purchaseFrequency"
          label="Frequency"
          options={CustomerLeadPurchaseFrequencyOptions}
          description='How often do you purchase "product"?'
        />
      </div>
      <div className="customer-lead-step-quantities-tab__container__row">
        <TextInputField
          type="number"
          name="purchaseFrequencyQty"
          label="Frequency Qty"
          description="How many product items do you typically purchase each cycle?"
        />
      </div>
      <div className="customer-lead-step-quantities-tab__container__row">
        <YesNoSelectField
          name="contractPricing"
          label="Contract Pricing"
          description="Would you be interested in a yearly commitment to guarantee supply and price?"
        />
      </div>
      <div className="customer-lead-step-quantities-tab__container__row">
        <TextInputField name="additionalInfo" label="Additional Info" description="Anything else we should know?" />
      </div>

      <div className="customer-lead-step__layout__center__footer-actions">
        <CustomerLeadStepLayoutNextButton />
      </div>
    </div>
  );
}
